import { CommonObject } from 'types';
import { HTTPMethods } from 'enum/HTTPMethods';
import { IFilterCount } from 'components/shared/AppTable/components/TableFilters/TableFilters';
import { IBulksResponse } from 'interfaces/IApiRequests';
import apiInstance from './instances/apiInstances';
import {
  IEndpoints,
  IPlugIn,
  IPlugInDataResponse,
  IPlugInDeleteResponse,
  IPlugInsRequest,
  IPlugInsResponse, IPlugInStopResponse, IPlugInStoreData,
  IPlugInStoreRequest,
  IStoreResponse,
} from '../../interfaces/IPlugIn';

export const getPlugInStoreFiltersApi = async (): Promise<IFilterCount> => {
  const res = await apiInstance.get('/plug_in_store/count?filterBy=isPrivate');
  return res.data;
};

export const getPlugInsApi = async (data: IPlugInsRequest): Promise<IPlugInsResponse> => {
  const res = await apiInstance.get('/plug_ins', {
    params: {
      ...data,
    },
  });

  return res.data;
};

export const getPlugInApi = async (name: string, version: string): Promise<IPlugInDataResponse> => {
  const res = await apiInstance.get(`/plug_ins/${name}/${version}`);

  return res.data;
};

export const getPlugInByIdApi = async (plugInId: string): Promise<IPlugIn> => {
  const res = await apiInstance.get(`/plug_ins/${plugInId}`);

  return res.data;
};

export const getPlugInStoreApi = async (
  data: IPlugInStoreRequest,
  asAdmin: boolean,
): Promise<IStoreResponse> => {
  const res = await apiInstance.get(`/plug_in_store${asAdmin ? '/admin' : ''}`, {
    params: {
      ...data,
    },
  });

  return res.data;
};

export const removePlugIn = async (name: string, version: string):
    Promise<IPlugInDeleteResponse> => {
  const res = await apiInstance.delete(`/plug_ins/${name}/${version}`);

  return res.data;
};

export const removePlugInFromStoreApi = async (ids: string[]):
    Promise<IBulksResponse> => {
  const res = await apiInstance.delete('plug_in_store', { data: { ids } });

  return res.data;
};

export const updatePlugInAllowedDbIdsListApi = async (
  plugInId: string,
  allowedDbIds: { accountId: number, serviceId: number }[],
): Promise<IBulksResponse> => {
  const res = await apiInstance.put(`/plug_in_store/${plugInId}`, { allowedDbIds });
  return res.data;
};

export const startPlugInApi = async (data: any, name: string, version: string):
    Promise<IPlugInStoreData> => {
  const res = await apiInstance.post(`/plug_ins/${name}/${version}`, {
    ...data,
  });

  return res.data;
};
export const startPlugInInstanceApi = async (name: string, version: string, _id: string):
    Promise<IPlugInStopResponse> => {
  const res = await apiInstance.put(`/plug_ins/enable/${name}/${version}/${_id}`);

  return res.data;
};

export const updateInstanceSettings = async (name: string, version: string, _id: string, data: any):
  Promise<IPlugInStoreData> => {
  const res = await apiInstance.put(`/plug_ins/${name}/${version}/${_id}`, {
    ...data,
  });

  return res.data;
};

export const stopPlugInInstance = async (name: string, version: string, _id: string):
    Promise<IPlugInStopResponse> => {
  const res = await apiInstance.put(`/plug_ins/disable/${name}/${version}/${_id}`);

  return res.data;
};

export const deletePlugInInstance = async (name: string, version: string, _id: string):
    Promise<IPlugInStopResponse> => {
  const res = await apiInstance.delete(`/plug_ins/${name}/${version}/${_id}`);

  return res.data;
};

export const uploadPlugInApi = async (plugIn: FormData):
    Promise<IPlugInStoreData> => {
  const res = await apiInstance.post('/plug_in_store', plugIn);

  return res.data;
};

export const getEndpointsApi = async (plugInId: string, plugInInstanceId: string):
  Promise<IEndpoints[]> => {
  const res = await apiInstance.get(`/plug_ins/endpoints/${plugInId}/${plugInInstanceId}`);

  return res.data;
};

export const callEndpointApi = async (
  method: HTTPMethods,
  accountId: number,
  serviceId: number,
  plugInId: string,
  plugInInstanceId: string,
  endpointName: string,
  configOrBody?: CommonObject,
): Promise<any> => {
  const url = `/plug_ins/endpoints/${accountId}/${serviceId}/${plugInId}/${plugInInstanceId}/${endpointName}`;
  const res = await apiInstance[method](url, configOrBody);

  return res.data;
};
